import { Pipe, PipeTransform } from '@angular/core';
import { StockStatus } from '@models/api-search.models';
import { TranslationKey } from '@shared/translations/auto-generated/translation-key';

@Pipe({
    name: 'storeStockStatusTranslation',
    standalone: true
})
export class StoreStockStatusTranslationPipe implements PipeTransform {
    transform(stockStatus: StockStatus | null): TranslationKey {
        return stockStatus && stockStatus !== 'NoStock'
            ? stockStatus === 'Few'
                ? 'stock.store.fewInStock'
                : 'stock.store.inStock'
            : 'stock.store.outOfStock';
    }
}
